export class SaveStateLogInput {
    orderId: number = 0;
    userId: number = 0;
    newStateId: number = 0;
}